export default __webpack_public_path__ + "static/media/Champion_garen_HP.bec7537e.png";